import { render, staticRenderFns } from "./UserSelect2Table.vue?vue&type=template&id=773396b2&scoped=true"
import script from "./UserSelect2Table.vue?vue&type=script&lang=js"
export * from "./UserSelect2Table.vue?vue&type=script&lang=js"
import style0 from "./UserSelect2Table.vue?vue&type=style&index=0&id=773396b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773396b2",
  null
  
)

export default component.exports